import { useMemo, useEffect, useState, useRef } from "react";
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { CallApi, CommonModal, getTodayDate, getTodayDateTime } from '../../../../Components/common/CommonFunctions';
import feather_upload_cloud from '../../../../assets/images/feather_upload_cloud.svg';
import Trash from '../../../../assets/images/gray_delete.svg';
import { ReactComponent as RedTruck } from '../../../../assets/images/icon_svg/red_truker.svg'; 
import { ReactComponent as BlueFlight } from '../../../../assets/images/icon_svg/blue_flight.svg'; 
import { ReactComponent as RedAwb } from '../../../../assets/images/icon_svg/red_awb.svg'; 
import { ReactComponent as RedMap } from '../../../../assets/images/icon_svg/red_map.svg'; 
import { ReactComponent as RedClock } from '../../../../assets/images/icon_svg/red_clock.svg';  
import { ReactComponent as FileDownload } from '../../../../assets/images/icon_svg/file_download.svg';  
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { toast } from "react-toastify";

const ComparisonBlock = ({ comparison, difference }) => {
  const getColumnWidth = (index, totalHeaders) => {
    if (totalHeaders === 2) return '50%';
    if (totalHeaders === 3) return ['40%', '20%', '40%'][index];
    return 'auto';
  };
 const iconMap = {
  'airplane': <BlueFlight />,
  'truck-delivery': <RedTruck />,
  'package-off': <RedAwb />,
  'clock-outline': <RedClock />,
  'map-pin-off': <RedMap />,
};

  const isDateString = (value) =>
    typeof value === 'string' && !isNaN(Date.parse(value)) && value.includes('T');

  if (!Array.isArray(comparison) && comparison?.headers && comparison?.rows) {
    return (
      <div className="inner_comparison_card">
        <div className="table-wrapper table-responsive">
          <table className="borderless_table table">
            <thead>
              <tr>
                {comparison.headers.map((header, index) => (
                  <th
                    key={header.key}
                    style={{ width: header.width ?? getColumnWidth(index, comparison.headers.length) }}
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparison.rows.map((row, i) => (
                <tr key={i}>
                  {comparison.headers.map((header) => {
                    const value = row.cells?.[header.key];
                    return (
                      <td key={header.key} className={header.highlight ? 'red_text' : ''}>
                        {header.key === 'source' && row.icon && (
                          // <span className={`row_icon_wrap icon_${row.icon} me-2`} />
                          <span className="me-2">
                            {iconMap[row.icon]}
                          </span>
                        )}
                        {/* {value ? (isDateString(value) ? getTodayDateTime(value, 'DMY') : value) : '—'} */}
                        {value ? value : '—'}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {difference && (
          <div
            className="difference_badge">
            {difference.icon && iconMap[difference.icon]}
            <span>{difference.value ?? difference.label}</span>
          </div>
        )}
      </div>
    );
  }
  return null;
};
const DiscrepancyModal = ({ show, onHide, truckData, onReload, onDetails   }) => {
  
  const discrepancyDetail = truckData?.detail;
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [base64Files, setBase64Files] = useState([]);
  const [resolutionType, setResolutionType] = useState([])
  const isMounted = useRef(false);
  const [formData, setFormData] = useState({});

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const fetchResolutionType = async () => {
          CallApi({
              endPoint: "discrepancy/get-resolution-type",
              method: "get",
              onSuccess: (res) => {
                  const innerData = res.data.response_data;
                  const transformedData = innerData ? innerData.map(item => ({
                      value: item.value,
                      label: item.label
                  })) : [];
                  setResolutionType(transformedData);
              },
              onError: (msg) => console.error(msg)
          });
      };
      useEffect(() => {
        if (!truckData) return;
        setFiles([]);
        setBase64Files([]);
        setFormData({});
      }, [truckData?.id]);      
      useEffect(() => {
          if (isMounted.current) return;
          fetchResolutionType();
          isMounted.current = true;
      }, [])

     const handleResolveDiscrepancy = () => {
       if (!formData?.resolution_type) {
          toast.error("Resolution type is required");
          return;
        }
      const payload = {
        files: base64Files,
        discrepancy_id: [truckData?.id],
        ...formData
      };

      CallApi({
        endPoint: "discrepancy/resolve",
        method: "post",
        payload: payload,
        onSuccess: (res) => {
          if(res?.data?.response_code == 200){
          toast.success("Resolved successfully!");
          onReload?.(); 
          onHide();          
          } else {
            toast.error(res?.data?.response_msg || 'Error while Resolving');
          }
        },
        onError: (err) => {
          console.error(err);
        },
      });
    };

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    const newFiles = [];
    const newBase64 = [];

    for (let file of selectedFiles) {
      // optional size check (25MB)
      if (file.size > 25 * 1024 * 1024) {
        // you may show a toast or ignore
        continue;
      }
      try {
        const base64 = await getBase64(file);
        newFiles.push(file);
        newBase64.push({ base64, file_name: file.name });
      } catch (err) {
        console.error('Base64 conversion failed', err);
      }
    }
    setFiles(prev => [...prev, ...newFiles]);
    setBase64Files(prev => [...prev, ...newBase64]);
    fileInputRef.current.value = '';
    // If you need to store the files for later submission, you could keep them in a local state or pass them up.
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current?.click();
  };

  const handleDeleteFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
    setBase64Files(prev => prev.filter((_, i) => i !== index));
    fileInputRef.current.value = '';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    // Reuse the same logic as handleFileChange
    const syntheticEvent = { target: { files: droppedFiles } };
    handleFileChange(syntheticEvent);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleResolutionFormChange = (field , value) => {
    setFormData(prev => ({...prev, [field]: value}))
  }
  const DownloadImage = (filePath, fileName) => {
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
   const handleTruckOrderClick = () => {
    if (!truckData?.truck_plan_monitor_mapping_id || !onDetails) return;
    onDetails(truckData);
    onHide?.();
  };
  return (
    <>
    {console.log("files", files)}
    <CommonModal
      mSize="xl"
      show={show}
      onHide={onHide}
      title={`Resolve Discrepancy - ${truckData?.truck_number ?? ''}/${truckData?.truck_date ? getTodayDate(truckData.truck_date, 'DMY') : ''}`}
      subTitle="Provide resolution details to close this discrepancy."
      className="modal_bgw primary_modal"
      footer={
        <div className="d-flex justify-content-between w-100">
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button variant="primary" className="ms-auto"  onClick={handleResolveDiscrepancy}>Resolve Discrepancy</Button>
        </div>
      }
    >
      <div className="resolve_dis">
        <Row>
          <Col className="pe-0" sm={6}>
            <div className="primary_bg mb-2">
              <h6>
                Truck order details -{' '}
                <span
                  role="button"
                  className={'truck-order-link'}
                  onClick={handleTruckOrderClick}
                >
                  {truckData?.truck_number}/{truckData?.truck_date ? getTodayDate(truckData.truck_date, 'DMY') : '-'}
                </span>
              </h6>
              <Row className="mb-2">
                <Col sm={6}>
                  <div>
                    <label>Boardpoint</label>
                    <p>{truckData?.boardPoint || '-'}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div>
                    <label>Offpoint</label>
                    <p>{truckData?.offPoint || '-'}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <div>
                    <label>Schedule departure time (STD)</label>
                    <p>{truckData?.std ? getTodayDateTime(truckData?.std , 'DMY_SLASH') : '-'}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div>
                    <label>Schedule arrival time (STA)</label>
                    <p>{truckData?.sta ? getTodayDateTime(truckData?.sta , 'DMY_SLASH') : '-'}</p>
                  </div>
                </Col>
              </Row>
            </div>

            <Card className="primary_bg">
              <h6>Discrepancy Summary</h6>
              {discrepancyDetail ? (
                <>
                  <div className="mb-2">
                    <label>Discrepancy Type</label>
                    <p>{discrepancyDetail.discrepancy_summary?.discrepancy_type || '—'}</p>
                  </div>
                  <div className="mb-2">
                    <label>Discrepancy Description</label>
                    <p>{discrepancyDetail.discrepancy_summary?.discrepancy_description || '—'}</p>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label>Category</label>
                      <p>{discrepancyDetail.discrepancy_summary?.category || '—'}</p>
                    </div>
                    <div className="col-md-6">
                      <label>Identified On</label>
                      <p>{discrepancyDetail.discrepancy_summary?.identified_on || '—'}</p>
                    </div>
                  </div>
                  {discrepancyDetail.comparison && (
                    <div className="summary_card align-self-auto">
                      <ComparisonBlock
                        comparison={discrepancyDetail.comparison}
                        difference={discrepancyDetail?.difference}
                      />
                    </div>
                  )}
                </>
              ) : (
                <p className="text-muted">No discrepancy data available.</p>
              )}
            </Card>
          </Col>
          <Col sm={6}>
            <div className="summary_card h-100">
              <h6>Resolution Details</h6>
              <Form>
                <Form.Label>Resolution Type <span className="red">*</span></Form.Label>
                <Select
                  options={resolutionType}
                  onChange={(selected) => {
                      const selectedRosulation = resolutionType.find(option => option.value === selected.value);
                      setFormData(prev => ({
                          ...prev,
                          resolution_type: selected.value,
                      }));
                  }}
                  placeholder="Resolution Type"
                  className="autoslct w-100"
                  name="resolution_type"
                  value={resolutionType.find(option => option.value === formData.resolution_type)}
              />
                <Form.Label>Resolution Notes </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Describe what was done to resolve this discrepancy."
                  name='resolution_notes'
                  onChange={(e) => handleResolutionFormChange('resolution_notes', e.target.value)}
                  className="custom-textarea"
                />
                <Form.Label>Add Attachment</Form.Label>
                <div className="upload-wrapper p-4">
                  <div
                    className="upload-box"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                  >
                    <div className="upload-content text-center">
                      <h6 className="upload-title">
                        Select a file or drag and drop here
                      </h6>
                      <p className="upload-subtitle">
                        JPG, PNG or PDF, file size no more than 25MB
                      </p>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="upload-btn"
                        onClick={handleBrowseFiles}
                      >
                        SELECT FILE
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        hidden
                        accept="image/png,image/jpeg,application/pdf"
                        onChange={handleFileChange}
                        multiple
                      />
                    </div>
                  </div>
                </div>

                {/* Uploaded file list */}
                <div className="files_upload mt-3">
                  {/* Already-saved attachments (from formData / API) */}
                  {formData?.attachments?.length > 0 &&
                    formData.attachments.map((file, index) => {
                      const fileName = file.file_name;
                      const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                      const extension = fileName?.split(".").pop();
                      return (
                        <div className="file-item w-100" key={file.file_name + index}>
                          <FontAwesomeIcon
                            icon={faDownload}
                            onClick={() => DownloadImage(file.file_path, file.file_name)}
                          />
                          {baseName?.length <= 7
                            ? fileName
                            : `${baseName?.substring(0, 10)}... .${extension}`}
                        </div>
                      );
                    })}

                  {/* Newly selected (local) files */}
                  {files.map((file, index) => {
                    const fileName = file.name;
                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                    const extension = fileName?.split(".").pop();
                    return (
                      <div  className="file-item w-100"  key={file.name + index}>
                        <FileDownload />
                        {baseName?.length <= 7
                          ? fileName
                          : `${baseName?.substring(0, 10)}... .${extension}`}
                        <img
                          src={Trash}
                          onClick={() => handleDeleteFile(index)}
                          alt="delete_icon"
                        />
                      </div>
                    );
                  })}
                </div>
                                
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </CommonModal>
    </>
  );
};


export default DiscrepancyModal;